module.exports = __webpack_public_path__ + "static/media/twitter.1fcdfa46.png";